(() => {
  document.querySelectorAll('.bk-school').forEach(root => {
    const contents = root.querySelector('.sc-contents');
    const media = matchMedia('(max-width: 900px)');
    const links = [...root.querySelectorAll('.sc-contents a')];
    const chapters = links.map(link => root.querySelector(link.hash)).filter(Boolean);
    const current = root.querySelector('.sc-contents-current');
    const reading = root.querySelector('#school-reading');
    const readingEnd = root.querySelector('#school-reading-end');
    const readingShelf = root.querySelector('[data-school-reading-shelf]');
    const backTop = root.querySelector('[data-school-back-top]');
    const progressControls = [...root.querySelectorAll('[data-school-progress]')];
    let scheduled = false;
    let selectedChapter = '';
    let lastPercent = -1;
    const scheduleUpdate = () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(updateReader); }
    };
    const syncContents = () => {
      if (contents) contents.open = !media.matches;
      scheduleUpdate();
    };
    const selectChapter = id => {
      if (selectedChapter === id) return;
      selectedChapter = id;
      for (const link of links) {
        if (link.hash === '#' + id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
      const active = links.find(link => link.hash === '#' + id);
      if (current && active) current.textContent = active.textContent;
    };
    root.querySelectorAll('.sc-contents a,.sc-skip,.sc-cover-read,.sc-cover-share[href]').forEach(link => link.addEventListener('click', event => {
      const target = root.querySelector(link.hash);
      if (!target) return;
      event.preventDefault();
      if (contents && media.matches) contents.open = false;
      target.tabIndex = -1;
      target.focus({preventScroll: true});
      target.scrollIntoView({behavior: 'instant', block: 'start'});
      history.replaceState(null, '', link.hash);
      selectChapter(target.id);
      scheduleUpdate();
    }));
    if (backTop) backTop.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      root.tabIndex = -1;
      root.focus({preventScroll: true});
      window.scrollTo({top: 0, left: 0, behavior: 'instant'});
      history.replaceState(null, '', backTop.hash);
      scheduleUpdate();
    });
    function updateReader() {
      scheduled = false;
      const native = root.closest('[data-bk-solid-school]');
      if (native) {
        const declared = parseFloat(getComputedStyle(document.body).getPropertyValue('--height-header')) || 0;
        const visible = [...document.querySelectorAll('[data-sticky-header], .shopify-section-header, #shopify-section-header, header.header, .header-middle')]
          .map(el => el.getBoundingClientRect()).filter(r => r.top <= 2 && r.bottom > 0 && r.width > 0);
        root.style.setProperty('--school-header-offset', (Math.ceil(Math.max(declared, ...visible.map(r => r.bottom), 0)) + 24) + 'px');
      }
      const inset = Math.max(0, parseFloat(getComputedStyle(root).getPropertyValue('--school-header-offset')) || 0);
      const threshold = Math.max(120, inset + 24);
      let active = chapters[0];
      for (const chapter of chapters) {
        if (chapter.getBoundingClientRect().top <= threshold) active = chapter;
        else break;
      }
      if (active) selectChapter(active.id);
      const backTopVisible = window.scrollY > Math.max(400, window.innerHeight * 0.5);
      if (backTop) backTop.hidden = !backTopVisible;
      if (!reading || !readingEnd || !progressControls.length) return;
      const readingTop = reading.getBoundingClientRect().top;
      const endTop = readingEnd.getBoundingClientRect().top;

      const readingVisible = readingTop <= inset && endTop >= inset;
      if (readingShelf) readingShelf.hidden = !(readingVisible || (backTop && backTopVisible));
      const visibleBottom = window.visualViewport ? window.visualViewport.offsetTop + window.visualViewport.height : window.innerHeight;
      const shelfBounds = readingShelf && readingVisible ? readingShelf.getBoundingClientRect() : null;
      const viewportBottom = shelfBounds && shelfBounds.height > 0 ? Math.min(visibleBottom, shelfBounds.top) : visibleBottom;
      // Zero when the opening reaches its readable inset; complete when the last
      // editorial line reaches the unobscured bottom, above a visible reading shelf.
      // Sharing/navigation add no length.
      const travelled = inset - readingTop;
      const distance = Math.max(1, (endTop - readingTop) - (viewportBottom - inset));
      const rounded = Math.round(Math.max(0, travelled / distance) * 100);
      const percent = travelled >= distance ? 100 : Math.min(99, rounded);
      for (const control of progressControls) {
        if (percent !== lastPercent) {
          control.setAttribute('aria-valuenow', String(percent));
          control.style.setProperty('--sc-reading-percent', String(percent));
          control.querySelector('[data-school-progress-value]').textContent = percent + '%';
        }
        control.hidden = control.dataset.schoolProgress === 'floating' && !readingVisible;
      }
      lastPercent = percent;
    }
    // A single RAF queue serves current chapter, percentage and all layout changes.
    addEventListener('scroll', scheduleUpdate, {passive: true});
    addEventListener('resize', scheduleUpdate, {passive: true});
    addEventListener('hashchange', scheduleUpdate);
    addEventListener('pageshow', scheduleUpdate);
    root.addEventListener('toggle', scheduleUpdate, true);
    root.addEventListener('load', scheduleUpdate, true);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleUpdate, {passive: true});
      window.visualViewport.addEventListener('scroll', scheduleUpdate, {passive: true});
    }
    if ('ResizeObserver' in window) new ResizeObserver(scheduleUpdate).observe(root);
    if (document.fonts) document.fonts.ready.then(scheduleUpdate);
    media.addEventListener('change', syncContents);
    root.classList.add('sc-reader-ready');
    syncContents();
    updateReader();
  });
})();
